














import Input from '@/components/common/Input/Input.vue';
import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Number,
    },
    label: { type: String },
    isAvailable: { type: Boolean },
  },
  data: function () {
    return {};
  },
  computed: {
    elementCount(): undefined | number {
      const analysisResult =
        this.$store.getters.labelAnalysisResult[this.label];

      if (!analysisResult || analysisResult.element_count === undefined) {
        return undefined;
      }

      return analysisResult.element_count;
    },
  },
  watch: {
    elementCount: {
      handler: function (newVal) {
        // TBD Report Object
        if (!newVal) {
          this.$emit('update:isAvailable', false);
          return;
        }

        this.$emit('update:isAvailable', true);
      },
    },
  },
  components: { Input },
});
